<template>
  <div>
    <div v-show="!show_agents">
      <div class="d-flex flex-row-column justify-content-between">
        <div class="d-inline-block mb-2 mt-2">
          <span @click="reset" class="page-title">
            <router-link to="/lmt/deposit/create">Make a Deposit</router-link>
          </span>
          <img src="../../../assets/icons/iconNextPage.svg" class="mx-1" />
          <span class="page-title">{{ $t('agent_specific.choose_agent') }}</span>
        </div>
        <span class="d-flex flex-row-column">
          <span class="input-width-160 r-width-100 d-inline-block mr-3">
            <md-field>
              <label for="filter">Filter by status</label>
              <md-select
                v-on:input="filterResults($event,'status')"
                name="filter"
                id="filter"
                v-model="status"
              >
                <md-option value>Show All</md-option>
                <md-option value="1">Only Active</md-option>
                <md-option value="0">Only Inactive</md-option>
              </md-select>
            </md-field>
          </span>
        </span>
      </div>
      <hr class="hr-line" />
      <md-table
        v-if="items.length>0"
        :md-sort-fn="orderBy"
        v-model="items"
        :md-sort.sync="currentSort"
        :md-sort-order.sync="currentSortOrder"
      >
        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell :md-label="$t('general.agent_id')" md-sort-by="agent_id">{{ item.agent_id }}</md-table-cell>
          <md-table-cell :md-label="$tc('general.agent', 1)" md-sort-by="name">{{ item.name }}</md-table-cell>
          <md-table-cell
            md-label="Open Transactions"
            md-sort-by="transactions"
          >{{ item.transactions }}</md-table-cell>
          <md-table-cell md-label="Actions">
            <a
              href="#"
              v-if="item.transactions!=0"
              v-on:click="add_transactions(item.id)"
            >{{ $t('agent_specific.choose_agent') }}</a>
          </md-table-cell>
        </md-table-row>
      </md-table>

      <pagination
        v-on:change="paginationChange($event)"
        v-on:change_per_page="changePerPage($event)"
        v-if="items.length>0&&pagination"
        :meta="pagination.meta"
        :links="pagination.links"
        :per_page="per_page"
      />

      <empty-state v-if="!loading&&items.length==0" />

      <loading v-if="loading" />
    </div>
    <div v-show="show_agents">
      <deposit-transactions :data="data" :agent_id="agent_id" />
    </div>
  </div>
</template>
<script>
// import pagination methods paginationChange and changePerPage
import Pagination from "../../../mixins/pagination.js";

// import CRUD methods for users
import Users from "../../../mixins/users.js";

// Confirmation component before deleting user
import ConfirmDelete from "../../../components/owner/ConfirmDelete";

// mixin for loading data and state
import DataMixin from "../../../mixins/data.js";
import Transactions from "./Transactions";

export default {
  mixins: [Pagination, Users, DataMixin],
  components: {
    confirm: ConfirmDelete,
    "deposit-transactions": Transactions
  },
  props: ["data"],
  data() {
    return {
      status: 1,
      agents: [],
      agent_id: "",
      show_agents: 0,
      search_term: "",
      // url for loading data
      api_url: "/lmt/deposit/agents",
      //IMPORTANT loaded data is stored in items
      items: []
    };
  },
  created() {
    this.loadData();

    Event.$on("add-agents", data => {
      this.page = 1;
      this.per_page = 10;

      this.show_agents = 0;
    });
  },
  methods: {
    add_transactions(id) {
      this.$router.push({
        path: this.$route.path,
        query: { ...this.$route.query, page: 1, per_page: 10 }
      });
      this.agent_id = id;
      this.show_agents = 1;
    },
    reset() {
      Event.$emit("reset");
    }
  }
};
</script>